/** Result type for fail-soft validation; tiny narrowing guards. */

export type Result<T> = { ok: true; value: T } | { ok: false; error: string };

export function isRecord(x: unknown): x is Record<string, unknown> {
  return typeof x === "object" && x !== null && !Array.isArray(x);
}

export function isString(x: unknown): x is string {
  return typeof x === "string";
}

export function isArray(x: unknown): x is unknown[] {
  return Array.isArray(x);
}
